import * as Yup from 'yup'

import { confirmNewPassword, email, newPassword, oldPassword, password } from 'utils/yup'

export const LOGIN_SCHEMA = Yup.object().shape({ email, password })

export const RECOVERY_PASSWORD_SCHEMA = Yup.object().shape({ email })

export const CREATE_NEW_PASSWORD_SCHEMA = Yup.object().shape({ newPassword, confirmNewPassword })

export const CHANGE_PASSWORD_SCHEMA = Yup.object().shape({ oldPassword, newPassword, confirmNewPassword })
